import { Component, Input } from '@angular/core';
import { UserStatus } from '../../models/enums/user-status.enum';

@Component({
  selector: 'app-user-status',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.scss']
})
export class UserStatusComponent {
  @Input() status: UserStatus;
  public userStatus = UserStatus;
}
